import AgencyLabels from "@/models/Agencies/AgencyLabels";
import WeekOfYear from "../Shared/WeekOfYear";
import AgencyBrandThemeMode from "./AgencyBrandThemeMode";

export default class AgencyIdentifierDto {
    id: string;
    brandName: string;
    avatarUrl: string;
}